module.exports = __webpack_public_path__ + "static/media/Drughelp.care_Quick_Guide_version_3.9f5c7e25.pdf";